module.exports = __webpack_public_path__ + "img/Abfahrk_ToDo.a29d3c60.svg";